import React from 'react';

const priorityConfig = {
  P1: {
    bg: 'bg-danger-soft',
    text: 'text-danger',
    label: 'P1 Critical'
  },
  P2: {
    bg: 'bg-accent-soft',
    text: 'text-accent',
    label: 'P2 High'
  },
  P3: {
    bg: 'bg-warning-soft',
    text: 'text-warning',
    label: 'P3 Medium'
  },
  P4: {
    bg: 'bg-surface-tertiary',
    text: 'text-ink-secondary',
    label: 'P4 Low'
  },
  P5: {
    bg: 'bg-surface-tertiary',
    text: 'text-ink-tertiary',
    label: 'P5 Info'
  }
};

const PriorityBadge = ({ priority, size = 'sm', showLabel = false, className = '' }) => {
  if (!priority) return null;
  
  const config = priorityConfig[priority] || priorityConfig.P4;
  
  const sizeClasses = {
    xs: 'px-1.5 py-0.5 text-[10px]',
    sm: 'px-2 py-0.5 text-tiny',
    md: 'px-2.5 py-1 text-caption'
  };

  return (
    <span 
      className={`
        inline-flex items-center font-medium rounded
        ${config.bg} ${config.text}
        ${sizeClasses[size]}
        ${className}
      `}
    >
      {showLabel ? config.label : priority}
    </span>
  );
};

export default PriorityBadge;
